import _ from 'lodash'

export function setCookie (name, value, expirationDays) {
  let expiresDate = new Date()

  expiresDate.setTime(expiresDate.getTime() + (expirationDays * 24 * 60 * 60 * 1000))

  document.cookie = name + '=' + value + ';expires=' + expiresDate.toUTCString() + ';path=/'
}

export function getCookie (name) {
  const cookieName = name + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookieProps = decodedCookie.split(';')

  for (let i = 0; i < cookieProps.length; i++) {
    let cookieProp = _.trim(cookieProps[i])

    if (cookieProp.indexOf(cookieName) === 0) {
      return cookieProp.substring(cookieName.length, cookieProp.length)
    }
  }

  return ''
}
